import CrudCustom from '../../../libs/custom/CrudCustom';

let TranskripListService = new CrudCustom('/saldo-neraca-transkrip-list');
export default TranskripListService;
